import { render, staticRenderFns } from "./TheSearchResult.vue?vue&type=template&id=1df3167e"
import script from "./TheSearchResult.vue?vue&type=script&lang=js"
export * from "./TheSearchResult.vue?vue&type=script&lang=js"
import style0 from "./TheSearchResult.vue?vue&type=style&index=0&id=1df3167e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports